export const componentTemplateMetadataKey = Symbol('component:template');

export default function componentTemplate(template: string) {
    return (ctor: any) => {
        Reflect.defineMetadata(componentTemplateMetadataKey, template, ctor);
        return ctor;
    }
}